'use client';

import clsx from 'clsx';

import { Link } from '@northladder/i18n';
import { useAppConfigStore } from '@northladder/services';

import { RenexisLogoSVG, RenexisLogomarkSVG } from '../brand';

/**
 * -----------------------------------------------------------------------------
 * It renders the header of the sidebar with logo, close and toggle button.
 */
export function BrandHeader() {
  const { isSidebarExpanded } = useAppConfigStore();

  return (
    <div className="flex items-center">
      <div
        className={clsx(
          'group relative h-10 w-auto grow',
          isSidebarExpanded ? 'px-4' : 'flex justify-center'
        )}
      >
        <Link
          className={clsx(
            'w-fit cursor-pointer',
            isSidebarExpanded ? 'block' : 'hidden'
          )}
          href="/app"
        >
          <RenexisLogoSVG
            className="w-32 hover:fill-green-700"
            isInverted={false}
          />
        </Link>

        <Link
          className={clsx(
            'w-fit cursor-pointer',
            isSidebarExpanded ? 'hidden' : ''
          )}
          href="/app"
        >
          <RenexisLogomarkSVG
            className="
              mt-1 w-8 fill-green-600 transition-all duration-500
              ease-in-out hover:fill-green-700
            "
            invert={false}
          />
        </Link>
      </div>
    </div>
  );
}
